export default "__VITE_ASSET__bWAHc9eC__"